<div class="date-range-box">
    <div class="date start">
        <span class="month">{{ t('landing.startMonth') }}</span>
        <span class="day">{{ t('landing.startDay') }}</span>
    </div>
    <div class="date-separator">
        <svg class="brown-arrow">
            <use xlink:href="#svg_brown_arrow"/>
        </svg>
    </div>
    <div class="date end">
        <span class="month">{{ t('landing.endMonth') }}</span>
        <span class="day">{{ t('landing.endDay') }}</span>
    </div>
</div>